import React from 'react';
import { IconWrap } from './IconWrap';
import useTheme from '../hooks/useTheme';

interface MetaRowProps {
  icon: React.ReactNode;
  label?: string;
  value: string;
  style?: React.CSSProperties;
}

export const MetaRow: React.FC<MetaRowProps> = ({ icon, label, value, style = {} }) => {
  const { theme } = useTheme();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '14px',
        color: theme.text.muted,
        ...style,
      }}
    >
      <IconWrap icon={icon} size={16} color="primary" />
      {label && <span style={{ fontWeight: 500 }}>{label}:</span>}
      <span style={{ color: theme.text.primary }}>{value}</span>
    </div>
  );
};

